/* eslint-disable react-hooks/exhaustive-deps */
import { tokens } from "../../../../theme";
import {
  Box,
  Checkbox,
  FormLabel,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import Select from "../../../../components/SearchableSelect";
import { submitRequestDialogStyles as styles } from "../../styles";
import MultiSelect from "../../../../components/MultiSelect";

// Selectable card per cloud: the head row toggles inclusion, and the tenant
// select + DB software multi-select appear only while the card is selected.
const CloudSpecificItem = ({ payload, setPayload, cloud, runningTenants }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  const selected = Boolean(payload?.clouds?.[cloud]);

  const toggleCloud = () => {
    setPayload((prev) => {
      if (prev?.clouds?.[cloud]) {
        const curr = structuredClone(prev);
        delete curr?.clouds?.[cloud];
        return curr;
      }
      return { ...prev, clouds: { ...prev?.clouds, [cloud]: {} } };
    });
  };

  return (
    <Box sx={styles.cloudCard(colors, selected)}>
      <Box sx={styles.cloudCardHead} onClick={toggleCloud}>
        <Checkbox
          size="small"
          checked={selected}
          sx={styles.cloudCardCheckbox}
          tabIndex={-1}
        />
        <Typography sx={styles.cloudCardName}>{cloud}</Typography>
        <Typography sx={styles.cloudCardCount}>
          {runningTenants?.length || 0} tenant
          {runningTenants?.length === 1 ? "" : "s"}
        </Typography>
      </Box>
      {selected && (
        <Box sx={styles.cloudCardControls}>
          <Box>
            <FormLabel required sx={styles.fieldLabel}>
              Tenant
            </FormLabel>
            <Select
              fullWidth
              size="small"
              displayEmpty
              sx={styles.tenantSelect}
              value={payload?.clouds?.[cloud]?.tenantDomain || ""}
              renderValue={(value) => value || "Select tenant"}
              onChange={(e) => {
                setPayload((prev) => ({
                  ...prev,
                  clouds: {
                    ...prev?.clouds,
                    [cloud]: {
                      ...prev.clouds?.[cloud],
                      tenantDomain: e.target.value,
                    },
                  },
                }));
              }}
            >
              {runningTenants?.map((tenant, i) => (
                <MenuItem value={tenant?.url} key={i}>
                  {tenant?.url}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box>
            <FormLabel required sx={styles.fieldLabel}>
              Db Software
            </FormLabel>
            <MultiSelect
              setSelectedItems={(newVal) => {
                setPayload((prev) => ({
                  ...prev,
                  clouds: {
                    ...prev?.clouds,
                    [cloud]: {
                      ...prev?.clouds?.[cloud],
                      dbSoftware: newVal,
                    },
                  },
                }));
              }}
              limit={1}
              sx={styles.cloudCardMultiSelect}
              textFieldProps={{ size: "small" }}
              defaultChipStyle
              populateItemsWhenEmpty={false}
              allItems={payload?.dbSoftware
                ?.filter((dbSoftware) =>
                  dbSoftware?.cloudsList?.includes(cloud)
                )
                ?.map(
                  (dbSoftware) =>
                    `${dbSoftware?.patchVersionName} {${dbSoftware?.majorVersion}}`
                )}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default CloudSpecificItem;
